import{z as o}from"zod";const e=o.record(o.string(),o.never()),r=o.object({success:o.boolean()});export{e as EmptyObject,r as SuccessObject};
